<ion-app>
  <ion-menu side="start" type="overlay" class="menu-sanduiche" menu-id="menuSanduiche" content-id="main">
    <ion-header class="head">
      <ion-toolbar class="ion-text-start" color="black-friday">
        <ion-title>Time Multipremiado</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="app-back">
      <ion-list color="light" class="ion-no-margin ion-no-padding" class="list-padd">
        <ng-container *ngFor="let item of menuPrincial">
          <ion-menu-toggle menu="menuSanduiche" auto-hide="false" *ngIf="getCondition(item.condition)">
            <ion-item [routerLink]="item.route" detail>
              <ion-icon [src]="item.icon.src" *ngIf="item.icon.src; else namedIcon"></ion-icon>
              <ng-template #namedIcon>
                <ion-icon [name]="item.icon.name" [class]="item.icon.class"></ion-icon>
              </ng-template>
              <ion-label>{{ item.label }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ng-container>

        <ion-menu-toggle menu="menuSanduiche" auto-hide="false">
          <ion-item (click)="touchLogout()" detail>
            <ion-icon name="log-out-outline" class="icon-logout"></ion-icon>
            <ion-label>Sair</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

      <!-- <p class="version">Versão {{modelLocator.version}}</p> -->
      <p class="version">
        Versão {{ appInfo.version }}
        {{ bundleVersion ? bundleVersion : '' }}
      </p>
      <p class="copyright">&copy; icons4u - we love marketing</p>

      <hr style="background: #f4f4f4" />
    </ion-content>
  </ion-menu>

  <ion-menu side="end" type="overlay" class="menu-usuario" menu-id="menuUsuario" content-id="main">
    <ion-header class="head">
      <ion-toolbar class="ion-text-start" color="black-friday">
        <ion-title>{{ modelLocator.dadosLogin.nome }}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ng-container *ngFor="let item of menuUsuario">
        <ion-menu-toggle menu="menuUsuario" auto-hide="false" *ngIf="getCondition(item.condition)">
          <ion-item [routerLink]="item.route" detail>
            <ion-icon [src]="item.icon.src" *ngIf="item.icon.src; else namedIcon"></ion-icon>
            <ng-template #namedIcon>
              <ion-icon [name]="item.icon.name" [class]="item.icon.class"></ion-icon>
            </ng-template>
            <ion-label>{{ item.label }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ng-container>

      <ion-row class="ion-justify-content-center">
        <div class="box-pontos" *ngIf="modelLocator.menu.pontuacao">
          <span class="tit">T-COINS</span>
          <span class="pontos_usuario pt">{{ modelLocator.saldo.tcoins_saldo ? modelLocator.saldo.tcoins_saldo : 0 }}</span>
          <span class="tit-expirar" *ngIf="modelLocator.pts_expirar !== 0">PONTOS A EXPIRAR:</span>
          <span class="pontos_usuario pt" *ngIf="modelLocator.pts_expirar !== 0">{{ modelLocator.pts_expirar }}</span>
        </div>
      </ion-row>

      <ion-row class="ion-justify-content-center">
        <div
          class="box-tickets"
          *ngIf="modelLocator.menu.pontuacao && modelLocator.dadosLogin.idperfil !== 18 && modelLocator.dadosLogin.idperfil !== 19"
        >
          <span class="pontos_usuario pt">{{ modelLocator.saldo.ticket_saldo ? modelLocator.saldo.ticket_saldo : 0 }}</span>
          <img src="../assets/image/ticket_menu.png" alt="" />
        </div>
      </ion-row>

      <ion-row class="area-badge row-badge" *ngIf="modelLocator.menu.classificacao">
        <ion-col>
          <div class="new-classifcation">
            <img *ngIf="modelLocator.dadosLogin.classificacao" [src]="modelLocator.dadosLogin.classificacao_imagem" />

            <!-- <ion-label>{{ modelLocator.dadosLogin.classificacao }}</ion-label> -->
          </div>
        </ion-col>
      </ion-row>

      <div class="backs" *ngIf="modelLocator.dadosLogin.classificacao" [style.--bg-color]="getBgColor()"></div>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>

  <!-- Popup challenge -->
  <ion-img
    class="balao_1 ion-hide-md-up"
    *ngIf="modelLocator.popup_challenge_1"
    (click)="touchPopUpChallenge(1)"
    src="../assets/image/popup_challenges/popup_1.png"
    alt="balao_1"
  ></ion-img>

  <ion-img
    class="balao_2 popup_2 ion-hide-md-up"
    *ngIf="modelLocator.popup_challenge_2"
    (click)="touchPopUpChallenge(2)"
    src="../assets/image/popup_challenges/popup_2.png"
    alt="balao_2"
  ></ion-img>

  <ion-img
    class="balao_2 popup_3 ion-hide-md-up"
    *ngIf="modelLocator.popup_challenge_3"
    (click)="touchPopUpChallenge(3)"
    src="../assets/image/popup_challenges/popup_3.png"
    alt="balao_3"
  ></ion-img>

  <ion-img
    class="balao_4 popup_4 ion-hide-md-up"
    *ngIf="modelLocator.popup_challenge_4"
    (click)="touchPopUpChallenge(4)"
    src="../assets/image/popup_challenges/popup_4.png"
    alt="balao_4"
  ></ion-img>
</ion-app>
